export enum AllocationType {
    Factory = 1,
    Customer = 2,
    FactorySantos = 3,
    FullHome = 4
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/AllocationType.ts